module.exports = __WEBPACK_EXTERNAL_MODULE_264__;


//////////////////
// WEBPACK FOOTER
// external {"amd":"openfl/display/Stage","root":["openfl","display","Stage"],"commonjs":"openfl/display/Stage","commonjs2":"openfl/display/Stage"}
// module id = 264
// module chunks = 0